import React from 'react'
import PlanAccessMessages from '../PlanAccessMessages/index'

interface PlanAccessMessagesProps {
  eligibility: Map<string, unknown>
  page: string
}

const ConnectedPlanAccessMessages = PlanAccessMessages as React.ComponentType<
  PlanAccessMessagesProps
>

interface ModalPlanAccessProps {
  eligibility: Map<string, unknown>
  page: string
}

function ModalPlanAccess (props: ModalPlanAccessProps) {
  const { eligibility, page } = props

  return (
    <div className="modal-plan-access">
      <ConnectedPlanAccessMessages eligibility={eligibility} page={page} />
    </div>
  )
}

export default ModalPlanAccess
